import { render, staticRenderFns } from "./HistoricoDocumentos.vue?vue&type=template&id=60e44c7a&scoped=true"
import script from "./HistoricoDocumentos.vue?vue&type=script&lang=js"
export * from "./HistoricoDocumentos.vue?vue&type=script&lang=js"
import style0 from "./HistoricoDocumentos.vue?vue&type=style&index=0&id=60e44c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e44c7a",
  null
  
)

export default component.exports